import React from 'react';

export const typeList = [
  { type: 0, name: '共通' },
  { type: 1, name: 'タワークレーン' },
  { type: 2, name: 'クローラクレーン' },
  { type: 6, name: 'ラフテレーンクレーン' },
  { type: 7, name: 'エレベータ' },
  { type: 3, name: '車輌系建設機械' },
  { type: 4, name: 'フォークリフト' },
  { type: 5, name: '高所作業車' },
  { type: 8, name: '積載形トラッククレーン' },
  { type: 9, name: '作業船（揚重機）', isDefault: true },
  { type: 10, name: '作業船（機材）', isDefault: true },
];

const commonCodeList = [
  { code: 11, name: '押印欄（左）' },
  { code: 12, name: '押印欄（中央）' },
  { code: 13, name: '押印欄（右）' },
];

export const craneAndMachineryCodeList = [
  { code: 1, name: '作業点検・対策欄その１' },
  { code: 2, name: '作業点検・対策欄その２' },
  { code: 3, name: '作業点検・対策欄その３' },
  { code: 4, name: '作業点検・対策欄その４' },
  { code: 5, name: 'オペレーターの一言欄' },
];

const getErrorMessage = (errors, index, column) => {
  if (errors[index] && errors[index][column]) {
    return <div className='validate-message show'>{errors[index][column]}</div>;
  } else {
    return null;
  }
};

export const CranePrintSentenceContents = ({
  callbacks,
  cranePrintSentences,
  errors,
}) => (
  <div className='setting-main__table'>
    <table className='document-setting-table'>
      {typeList.map((typeData, typeKey) => (
        <SentenceType
          key={typeKey}
          callbacks={callbacks}
          typeData={typeData}
          typeKey={typeKey}
          cranePrintSentences={cranePrintSentences}
          errors={errors}
        />
      ))}
    </table>
  </div>
);

export class SentenceType extends React.Component {
  state = {
    isGroupOpen: true,
  };

  groupToggle = () => {
    this.setState(prevState => ({
      isGroupOpen: !prevState.isGroupOpen,
    }));
  };

  render() {
    const {
      callbacks,
      typeData,
      typeKey,
      cranePrintSentences,
      errors,
    } = this.props;
    const codeList =
      typeData.type === 0 ? commonCodeList : craneAndMachineryCodeList;

    return (
      <tbody
        key={typeKey}
        id={`group1${typeData.type}`}
        className={`document-setting-table__group ${
          this.state.isGroupOpen ? 'show' : ''
        }`}
      >
        <tr className='document-setting-table__section-header'>
          <td className='document-setting-table__open-button'>
            <button
              id={`btn-group1${typeData.type}-toggle`}
              className='btn-icon--sm'
              onClick={this.groupToggle}
            >
              <i
                className={`i-warrow-${
                  this.state.isGroupOpen ? 'top' : 'bottom'
                } i-2x`}
              />
            </button>
          </td>
          <td className='value-table document-setting-table__label'>
            {typeData.name}
          </td>
          <td className='value-table document-setting-table__input' />
        </tr>
        {codeList.map((codeData, codeKey) => {
          return cranePrintSentences.map((cranePrintSentence, index) => {
            if (
              cranePrintSentence.type === typeData.type &&
              cranePrintSentence.code === codeData.code
            ) {
              return (
                <SentenceContent
                  index={index}
                  callbacks={callbacks}
                  codeData={codeData}
                  codeKey={codeKey}
                  key={codeKey}
                  cranePrintSentence={cranePrintSentence}
                  errors={errors}
                />
              );
            }
          });
        })}
      </tbody>
    );
  }
}

export const SentenceContent = ({
  index,
  callbacks,
  codeData,

  // eslint-disable-next-line no-unused-vars
  codeKey,
  cranePrintSentence,
  errors,
}) => (
  <tr key={index} className='document-setting-table__item '>
    <td className='value-table document-setting-table__space' />
    <td className='value-table document-setting-table__label'>
      <div className='value-table__txt--10'>{codeData.name}</div>
    </td>
    <td className='value-table document-setting-table__input'>
      <input
        type='text'
        name='sentence'
        style={{ width: '90%' }}
        maxLength='512'
        className='--col-xl-8 --col-lg-8 --col-md-12 --col-xs-12'
        value={cranePrintSentence.sentence}
        onChange={e => {
          callbacks.table.onChangeSentence(e, index);
        }}
      />
      {getErrorMessage(errors, index, 'sentence')}
    </td>
  </tr>
);



// WEBPACK FOOTER //
// ./src/components/tables/CranePrintSentence.jsx